import { wgApi } from '../../../app/src/features/api/wgApi';
import { Offer } from '../../../../types/Offer';
import { useQuery } from 'react-query';
import { useDistributionId } from '../../../app/src/features/authentication/api/get/getDistribution';

interface Params {
  distributionId: string;
  offerId: string;
  revision?: number;
}

export const getOfferById = async ({
  distributionId,
  offerId,
  revision = 0,
}: Params) => {
  const path = `/v1/api/broker/v1/api/distributions/${distributionId}/offers/${offerId}/revisions/${revision}`;
  const { data, isError } = await wgApi.get<Offer>(path);
  if (isError) throw new Error();
  return data;
};

type UseOfferParams = Omit<Params, 'distributionId'>;

export const getOfferQKey = ({ offerId, revision }: UseOfferParams) => [
  'portfolio',
  'offer',
  offerId,
  revision,
];

export const useOffer = ({ offerId, revision }: UseOfferParams) => {
  const distributionId = useDistributionId();

  return useQuery(
    getOfferQKey({ offerId, revision }),
    () => getOfferById({ distributionId, offerId, revision }),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  );
};
